<!-- Covers the whole app and takes every click: only the panel's own buttons do anything. -->
<div class="tour-layer" [class.tour-dim]="!spot" cdkTrapFocus>
  <div
    class="tour-spot"
    *ngIf="spot"
    [class.tour-glide]="glide"
    [class.tour-spot-help]="phase.kind === 'hint'"
    [style.left.px]="spot.left"
    [style.top.px]="spot.top"
    [style.width.px]="spot.width"
    [style.height.px]="spot.height"
  ></div>

  <p class="visually-hidden" aria-live="polite">{{ announcement }}</p>

  <div
    #panel
    class="tour-tip"
    *ngIf="phase.kind === 'step' && step"
    role="dialog"
    aria-modal="true"
    aria-labelledby="tour-title"
    aria-describedby="tour-text"
    [class.tour-pending]="searching"
    [class.tour-placed]="!!panelAt"
    [style.left.px]="panelAt?.left"
    [style.top.px]="panelAt?.top"
  >
    <div class="tour-tip-top">
      <span class="tour-stepno">Step {{ index + 1 }} of {{ steps.length }}</span>
      <button type="button" class="tour-x" aria-label="Close the guide" (click)="skip()">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </div>
    <h3 id="tour-title" class="tour-title">{{ step.title }}</h3>
    <p id="tour-text" class="tour-text">{{ step.text }}</p>
    <div class="tour-map" *ngIf="step.aivor && step.sage">
      <b>Aivor: {{ step.aivor }}</b>
      <i class="bi bi-arrow-right" aria-hidden="true"></i>
      <span class="visually-hidden">maps to</span>
      <b>Sage: {{ step.sage }}</b>
    </div>
    <div class="tour-dots" aria-hidden="true">
      <i *ngFor="let s of steps; let i = index" [class.on]="i === index"></i>
    </div>
    <div class="tour-acts">
      <button type="button" class="tour-skip" (click)="skip()">Skip tour</button>
      <span class="tour-sp"></span>
      <button type="button" class="btn-secondary" *ngIf="index > 0" (click)="back()">Back</button>
      <button #primary type="button" class="btn-teal-gradient" (click)="next()">{{ isLast ? 'Finish' : 'Next' }}</button>
    </div>
  </div>

  <div
    #panel
    class="tour-finish"
    *ngIf="phase.kind === 'finish'"
    role="dialog"
    aria-modal="true"
    aria-labelledby="tour-finish-title"
    aria-describedby="tour-finish-text"
  >
    <div class="tour-tick" aria-hidden="true"><i class="bi bi-check-lg"></i></div>
    <h3 id="tour-finish-title" class="tour-title">You have seen all {{ steps.length }} steps</h3>
    <p id="tour-finish-text" class="tour-text">You can run the guide again any time from the Help button at the top of this page.</p>
    <div class="tour-finish-acts">
      <button #primary type="button" class="btn-teal-gradient" (click)="runAgain()">Run the guide again</button>
      <button type="button" class="btn-secondary" (click)="markDone()">Mark as done</button>
    </div>
  </div>

  <div
    #panel
    class="tour-hint"
    *ngIf="phase.kind === 'hint'"
    role="dialog"
    aria-modal="true"
    aria-labelledby="tour-hint-text"
    [class.tour-pending]="searching"
    [class.tour-placed]="!!panelAt"
    [style.left.px]="panelAt?.left"
    [style.top.px]="panelAt?.top"
  >
    <p id="tour-hint-text" class="tour-text">
      <b>Need a refresher?</b><br />
      Press <b>Help</b> any time to run the {{ steps.length }}-step guide again.
    </p>
    <button #primary type="button" class="btn-teal-gradient" (click)="gotIt()">Got it</button>
  </div>
</div>
